webpackJsonp([73640758852966],{

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CtaButton = function CtaButton(_ref) {
	    var text = _ref.text,
	        href = _ref.href,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "a",
	        { href: href, className: "cta-button " + className },
	        text
	    );
	};
	
	CtaButton.defaultProps = {
	    className: ""
	};
	
	exports.default = CtaButton;
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Nav = __webpack_require__(47);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Logo = __webpack_require__(46);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var destination = this.props.destination;
	
	
	    if (destination) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper-main_header' },
	        _react2.default.createElement(_Logo2.default, { className: 'wrapper-main_logo' }),
	        _react2.default.createElement(_Nav2.default, { className: 'wrapper-main_nav', destination: true })
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrapper-main_header' },
	        _react2.default.createElement(_Logo2.default, { className: 'wrapper-main_logo' }),
	        _react2.default.createElement(_Nav2.default, { className: 'wrapper-main_nav' })
	      );
	    }
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CtaButton = __webpack_require__(32);
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderInfo = function HeaderInfo() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'wrapper-main_info' },
	        _react2.default.createElement(
	            'p',
	            { className: 'wrapper-main_info-p magenta' },
	            _react2.default.createElement(
	                'span',
	                { className: 'wrapper-main_info-text' },
	                'August 18th, 2018'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'wrapper-main_info-text' },
	                'Ciudad Cultural Konex'
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'wrapper-main_info-text' },
	                'Buenos Aires, Argentina'
	            ),
	            _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/css_conf_ar', target: '_blank', className: 'wrapper-main_info-twitter' },
	                _react2.default.createElement(
	                    'svg',
	                    { className: 'twitter-logo', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 400 400' },
	                    _react2.default.createElement(
	                        'title',
	                        null,
	                        'Twitter Logo'
	                    ),
	                    _react2.default.createElement('rect', { fill: 'none', width: '400', height: '400' }),
	                    _react2.default.createElement('path', { fill: '#1da1f2', d: 'M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23' })
	                )
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'wrapper-main_info-tickets' },
	                _react2.default.createElement(_CtaButton2.default, { text: 'Get your tickets', href: '#tickets' })
	            )
	        )
	    );
	};
	
	exports.default = HeaderInfo;
	module.exports = exports['default'];

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo(_ref) {
	    var className = _ref.className;
	    return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', className: 'main-logo ' + className },
	        _react2.default.createElement('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '16 0 288 60', dangerouslySetInnerHTML: { __html: '<defs><path d="M12.004 0C5.389-.015.015 5.345 0 11.973v.013C-.015 18.606 5.329 23.985 11.936 24h.013c6.614.015 11.989-5.345 12.004-11.973C23.968 5.4 18.618.015 12.003 0zm.086 20.014c-.051 0-.104.005-.154.005l-.07-.002c-.847-4.103-5.243-7.28-10.754-7.912 0-.036-.007-.069-.007-.105 0-.048.01-.093.01-.14 5.494-.63 9.882-3.79 10.749-7.877l.072-.002c.05 0 .1.005.15.005.85 4.1 5.245 7.278 10.754 7.909 0 .035.008.069.008.105 0 .048-.01.093-.01.14-5.493.63-9.88 3.788-10.748 7.874z" id="logo"/><filter x="-217.1%" y="-175%" width="534.2%" height="533.3%" filterUnits="objectBoundingBox" id="logoa"><feOffset dy="10" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="14" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0.0274509804 0 0 0 0 0.0274509804 0 0 0 0 0.0235294118 0 0 0 1 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/><feOffset in="SourceAlpha" result="shadowOffsetOuter2"/><feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter2" result="shadowBlurOuter2"/><feColorMatrix values="0 0 0 0 0.0274509804 0 0 0 0 0.0274509804 0 0 0 0 0.0235294118 0 0 0 1 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/><feMerge><feMergeNode in="shadowMatrixOuter1"/><feMergeNode in="shadowMatrixOuter2"/></feMerge></filter></defs><g fill-rule="nonzero" fill="none"><path d="M73.621 34.32c4.123 0 6.946-1.256 8.716-2.693l1.905 2.155c-2.577 2.717-6.587 3.907-10.598 3.907-7.148 0-11.674-3.233-11.674-8.689 0-5.455 4.818-8.688 11.719-8.688 4.01 0 7.865 1.19 10.307 3.614l-1.636 2.178c-2.442-1.616-4.795-2.424-8.693-2.424-5.132 0-8.717 1.953-8.717 5.298 0 3.345 3.361 5.343 8.671 5.343zm23.5-7.049c7.484.629 11.091 1.415 11.091 5.209 0 3.188-3.114 5.209-10.374 5.209-6.587 0-10.442-2.11-12.055-3.593l1.569-2.29c1.837 1.056 4.974 2.56 10.71 2.56 4.683 0 7.17-.517 7.17-1.73 0-1.211-1.569-1.638-8.223-2.2-7.686-.65-10.643-1.481-10.643-4.983 0-3.57 4.168-5.141 10.128-5.141 4.974 0 8.805 1.145 11.293 3.233l-1.569 2.267c-2.51-1.302-5.602-2.178-9.657-2.178-3.899 0-7.238.427-7.238 1.752 0 1.212 1.636 1.369 7.798 1.885zm23.858 0c7.484.629 11.091 1.415 11.091 5.209 0 3.188-3.114 5.209-10.374 5.209-6.587 0-10.442-2.11-12.055-3.593l1.569-2.29c1.837 1.056 4.974 2.56 10.71 2.56 4.683 0 7.17-.517 7.17-1.73 0-1.211-1.569-1.638-8.223-2.2-7.686-.65-10.643-1.481-10.643-4.983 0-3.57 4.168-5.141 10.128-5.141 4.974 0 8.805 1.145 11.293 3.233l-1.57 2.267c-2.509-1.302-5.6-2.178-9.656-2.178-3.9 0-7.238.427-7.238 1.752 0 1.212 1.636 1.369 7.798 1.885zm26.715 7.05c4.123 0 6.946-1.257 8.716-2.694l1.905 2.155c-2.577 2.717-6.588 3.907-10.598 3.907-7.148 0-11.674-3.233-11.674-8.689 0-5.455 4.818-8.688 11.719-8.688 4.01 0 7.864 1.19 10.307 3.614l-1.636 2.178c-2.442-1.616-4.795-2.424-8.693-2.424-5.132 0-8.717 1.953-8.717 5.298 0 3.345 3.36 5.343 8.671 5.343zm24.687-14.01c6.946 0 12.01 3.233 12.01 8.689 0 5.455-5.064 8.688-12.01 8.688-6.879 0-11.943-3.233-11.943-8.688 0-5.456 5.064-8.689 11.943-8.689zm0 14.01c5.468 0 9.03-1.909 9.03-5.321 0-3.39-3.562-5.32-9.03-5.32-5.4 0-8.962 1.93-8.962 5.32 0 3.412 3.562 5.32 8.962 5.32zm17.965-10.328V37.42h-2.98V20.58h3.921l15.102 13.47v-13.47h2.98v16.838h-3.92l-15.103-13.426zm22.693-3.412h18.508v3.323h-15.528v3.457h14.452v3.255H216.02v6.803h-2.98V20.58zm50.72 16.277v.56h-3.339l-2.756-4.377H245.79l-2.755 4.378h-3.34v-.561l10.644-16.277h2.778l10.643 16.277zm-12.032-13.179l-3.899 6.174h7.798l-3.899-6.174zm17.315 13.74h-2.98V20.58h15.215c4.167 0 6.61 1.594 6.61 5.208 0 3.188-1.995 4.558-5.445 4.805l4.93 6.264v.56h-3.496l-4.863-6.465h-9.97v6.466zm12.884-13.56h-12.884v3.906h12.884c2.106 0 2.98-.763 2.98-1.953s-.874-1.953-2.98-1.953z" fill="#EE952C"/><g transform="translate(27 17)"><use fill="#000" filter="url(#logoa)" xlink:href="#logo"/><use fill="#96A0FF" fill-rule="evenodd" xlink:href="#logo"/></g></g>'
	            }
	        })
	    );
	};
	
	Logo.defaultProps = {
	    className: ""
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_React$Component) {
	    _inherits(Nav, _React$Component);
	
	    function Nav() {
	        _classCallCheck(this, Nav);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Nav.prototype.render = function render() {
	        var _props = this.props,
	            destination = _props.destination,
	            className = _props.className;
	
	
	        if (destination === true) {
	            return _react2.default.createElement(
	                "nav",
	                { className: "main-nav " + className },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "main-nav_list" },
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#speakers" },
	                            "Speakers"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#schedule" },
	                            "Schedule"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#tickets" },
	                            "Tickets"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#venue" },
	                            "Venue"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#sponsors" },
	                            "Sponsors"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../code-of-conduct" },
	                            "Code of Conduct"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "../#team" },
	                            "Team"
	                        )
	                    )
	                )
	            );
	        } else {
	            return _react2.default.createElement(
	                "nav",
	                { className: "main-nav " + className },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "main-nav_list" },
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#speakers" },
	                            "Speakers"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#schedule" },
	                            "Schedule"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#tickets" },
	                            "Tickets"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#venue" },
	                            "Venue"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#sponsors" },
	                            "Sponsors"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "code-of-conduct" },
	                            "Code of Conduct"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "main-nav_item" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "main-nav_link", href: "#team" },
	                            "Team"
	                        )
	                    )
	                )
	            );
	        }
	    };
	
	    return Nav;
	}(_react2.default.Component);
	
	Nav.defaultProps = {
	    className: ""
	};
	
	exports.default = Nav;
	module.exports = exports["default"];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(44);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderInfo = __webpack_require__(45);
	
	var _HeaderInfo2 = _interopRequireDefault(_HeaderInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamPage = function teamPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'wrapper wrapper-team the-numbers' },
	        _react2.default.createElement(
	            'div',
	            { className: 'wrapper-main wrapper-main_hero wrapper-main_hero-team' },
	            _react2.default.createElement(_Header2.default, { destination: true }),
	            _react2.default.createElement(
	                'h1',
	                { className: 'section-title' },
	                'How we made CSSConf Argentina'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Nine months worth of teamwork and about $20,000 USD is what it took to build this non-profit conference for 400 attendees. it was hard work, but it was worth it.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'The conference took place on August 18th, 2018; we started planning at the end of December 2017 and the first question we asked ourselves was ',
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    '\u201CWhat are our main goals?\u201D'
	                ),
	                ' Community and great content. As simple as it sounds it wasn\u2019t easy to achieve because it is, after all, all about the money.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Argentina is no first-world country and it is also uncommon to have tech conferences (JSConf and Ekoparty helped pave the way a few years back). Companies don\u2019t usually cover employees\u2019 tickets and with an average monthly salary of ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://sysarmy.wordpress.com/2018/09/04/resultados-de-la-encuesta-de-sueldos-2018-2/', target: '_blank', rel: 'noopener' },
	                    '$900 / 1300 USD'
	                ),
	                ' web developers can find it very hard, if not impossible, to pay their tickets out of their own pockets. Therefore, it is only a matter of mathematics. A $400 USD ticket might sound affordable in your home country but it definitely doesn\u2019t work like that everywhere else.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Yes, scholarships help (see numbers below to learn what we did there) but they are only palliatives. ',
	                _react2.default.createElement(
	                    'strong',
	                    { className: 'item-text_magenta' },
	                    'Money is exclusionary'
	                ),
	                '. We don\u2019t want to force people into having to rely on scholarships; doing that feels like creating a new barrier of entry. Not everybody feels they \u201Cdeserve\u201D this kind of ticket and no matter the efforts, some will never feel \u201Cworthy enough\u201D to apply.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Ticket price is an integral part of our inclusion and community efforts.'
	            ),
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Argentina\u2019s economy 101'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    '(In case you are not familiar with it)'
	                ),
	                _react2.default.createElement('br', null),
	                'This beautiful country has a strange relationship with the US Dollar, it\u2019s like a thing\u2026 Dual-currency or whatever you wish to call it. I\u2019m pretty sure you can google a lot about that if you are interested. What\u2019s important about it here is that currency exchange tends to be a roller coaster.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'January 2nd, 2018:',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.cotizacion-dolar.com.ar/dolar-historico-2018.php', target: '_blank', rel: 'noopener' },
	                    '1 US Dollar was equivalent to $18.76 Argentinian pesos'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'August 30th, 2018:',
	                _react2.default.createElement('br', null),
	                '1 US Dollar was equivalent to $38.26 Argentinian pesos'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'While reading this document bear in mind that flight tickets, hotel reservations and even the conference catering is affected by the rise of US Dollar exchange rate and inflation.'
	            ),
	            _react2.default.createElement(
	                'h2',
	                null,
	                'The numbers'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Ok, so this is what you are here for. Without further ado, here are the two most important numbers:'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'How much we raised'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'How much we spent'
	                )
	            ),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'How much we raised'
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'the-numbers_table item-text' },
	                _react2.default.createElement(
	                    'caption',
	                    { className: 'cloak' },
	                    'Raised amounts'
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'From Sponsors'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$11,769 USD'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '56.5%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'From Tickets'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$9,067 USD'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '43.5%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Total'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '$20,836 USD'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '100%'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Sponsors'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'We are more than grateful for each of our sponsors: Google, DataArt, Mercado Libre, Virtualmind, Stensul, Acamica, OLX and Mozilla. Without them, CSSConf Argentina wouldn\u2019t have happened.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'These sponsors provided:'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    '24 hotel nights'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    '3 international flights'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Venue rental'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Speakers\u2019 dinner'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Swag (comfy socks and bag)'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Translation service'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Before we began looking for sponsors we made two important decisions:'
	            ),
	            _react2.default.createElement(
	                'ol',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'bold' },
	                        'We would not sell speaking slots:'
	                    ),
	                    _react2.default.createElement('br', null),
	                    'Nothing against that but we wanted to make sure that our conference remained as neutral as possible and with only 8 slots for speakers and an open Call For Proposals we agreed that it would be better to keep speakers independent of sponsoring packages.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'bold' },
	                        'If possible, we would get things covered by sponsors, instead of them giving us the money directly:'
	                    ),
	                    _react2.default.createElement('br', null),
	                    'This might sound strange but it was highly beneficial for all. We are a non-profit conference so by letting sponsors cover hotels or flights directly we provided transparency on how we handled expenses and at the same time it was a little less tax-hassle for us as organizers!'
	                )
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Tickets'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Expenses that weren\u2019t covered by sponsors were covered by ticket sales.'
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'the-numbers_table item-text' },
	                _react2.default.createElement(
	                    'caption',
	                    { className: 'cloak' },
	                    'Tickets by category'
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Tickets sold ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '(paid)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '262'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '66.2%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Tickets scholarships ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '(free)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '70'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '19.5%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Tickets sponsors ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '(free)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '28'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '7.1%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Tickets crew ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '(free)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '32'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '8.1%'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tfoot',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        { className: 'bold' },
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Total'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '392'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '100%'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'the-numbers_table item-text' },
	                _react2.default.createElement(
	                    'caption',
	                    { className: 'cloak' },
	                    'Avegares of ticket prices and numbers'
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Average ticket price',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'not-bold' },
	                                '($9,067 USD / 262)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$34.6 USD',
	                            _react2.default.createElement('br', null),
	                            '(Ticket Holders paid an extra 6% charge of Eventbrite)'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Money (from ticket sales) available per person',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'not-bold' },
	                                '($9,067 USD / 392)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$23.13 USD'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Money available per attendee',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'not-bold' },
	                                '($20,836 USD / 392)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$50.15 USD'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'How much we spent'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Values are shown in Argentinean pesos (ARS).'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Most expenses were in pesos, affected by the rise of the dollar. We took an average of 26 / 27 pesos per USD Dollar to make this graph, but bear in mind that numbers are not exact since doing that would require us to go back in time nine months through loads of emails and check each day with each value of US Dollar and\u2026 Nope.'
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'the-numbers_table item-text' },
	                _react2.default.createElement(
	                    'caption',
	                    { className: 'cloak' },
	                    'Avegares of ticket prices and numbers'
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Taxes'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$8,490 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '1.55%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Organizing'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$3,895 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '0.7%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Speakers'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$273,251 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '49.35%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Communication'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$76,168 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '13.75%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Venue'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$191,826 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '34.65%'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tfoot',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row', className: 'bold' },
	                            'Total ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '$553,630 ARS'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '100%'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row', className: 'bold' },
	                            'Total USD'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '$20,505 USD'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '100%'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'What does... include?'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Taxes:'
	                    ),
	                    ' ... We guess there\u2019s not much to explain here.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Organizing:'
	                    ),
	                    ' Meetings since December, if we took a coffee or a beer or a tea, conference paid that.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Speakers:'
	                    ),
	                    ' Hotel with breakfast (24 nights total), 5 international flights (no business class), 1 international ferry trip, speakers dinner, transportation (to/from airport, to/from venue), Argentinian chocolates ',
	                    _react2.default.createElement(
	                        'em',
	                        null,
	                        '(YES!)'
	                    ),
	                    ', 6 SUBE cards for transport inside the city with a charge of $80 pesos each.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Communication:'
	                    ),
	                    ' Domain name (valid for 2018 and 2019), Gmail service (also valid for 2018 and 2019), banners, sticky tags for badges, badges, lanyards and swag (socks and bags)'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Venue:'
	                    ),
	                    ' Renting of the venue itself, food and coffee service (includes vegan and gluten-free), insurance, tech stuff (microphones, switch, etc) and translation service'
	                )
	            ),
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Recap & final words'
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'the-numbers_table item-text' },
	                _react2.default.createElement(
	                    'caption',
	                    { className: 'cloak' },
	                    'Final numbers'
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Money raised'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$20,836 USD'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row' },
	                            'Money spent'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            '$20,505 USD'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tfoot',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { scope: 'row', className: 'bold' },
	                            'Money left'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'bold' },
	                            '$331 USD'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'FAQ'
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'item-text' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Are these numbers exact? Are there really $331 left?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'No. As we said above, getting the exact values would take loads of our time (and still probably not be exact). We believe there are around 500 to 200 USD left'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'What are you going to do with that money left?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'There are two possibilities, either save it for the next conference or spending it on translating and adding captions to videos. We will probably go for the latter even though it\u2019s probably not enough money to do that with all the videos.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'What would you improve?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Better flights for speakers (fewer connections)'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Fee for speakers (and for everyone that works on the event)'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Better coffee (it wasn\u2019t cheap and it wasn\u2019t tasty, but it\u2019s not our priority at all)'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Actually ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://adrianroselli.com/2018/11/conferences-speakers-please-caption-your-videos.html', target: '_blank', rel: 'noopener' },
	                                'save money for video translation and captions'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Save the money from ticket sales in US Dollars and not Argentinian Pesos to ',
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '(try to)'
	                            ),
	                            ' avoid inflation'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Why did this take SO long to publish?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'Life.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'When will the videos be up?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'Soon, hopefully!'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Is this the only way of organizing a non-profit conference?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'Nope, each conference has its own valid way of organizing, prioritizing and distributing funds.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'I have genuine, actionable feedback to share or an honest question I\'d like answered'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'item-text' },
	                        'Please email us at the conference email or DM us on Twitter (bear in mind we might take a few days to answer)'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'What can we, as attendees, do to make it easier for non-profit conferences to survive?'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Buy tickets in advance'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Buy diversity tickets if you can afford them'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Be nice'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'item-text' },
	                'Thanks for reading, my friend.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'wrapper-main' },
	            _react2.default.createElement(
	                'footer',
	                { className: 'footer footer-coc' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'footer-font' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:info@cssconfar.com', target: '_blank', rel: 'noopener' },
	                        'info (at) cssconfar.com'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'footer-text_twitter', href: 'https://twitter.com/css_conf_ar' },
	                        _react2.default.createElement(
	                            'svg',
	                            { className: 'twitter-logo', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 400 400' },
	                            _react2.default.createElement(
	                                'title',
	                                null,
	                                'Twitter Logo'
	                            ),
	                            _react2.default.createElement('rect', { fill: 'none', width: '400', height: '400' }),
	                            _react2.default.createElement('path', { fill: '#1da1f2', d: 'M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = teamPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-the-numbers-js-3f32dd4d5e37a03ebc1e.js